import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10.682 12.998c-.943 0-1.886-.359-2.604-1.077-.195-.195-.195-.512 0-.707s.512-.195.707 0c1.046 1.046 2.747 1.046 3.793 0l3.636-3.636c1.046-1.046 1.046-2.747 0-3.793s-2.747-1.046-3.793 0L9.353 6.853c-.195.195-.512.195-.707 0s-.195-.512 0-.707l3.068-3.068c1.436-1.436 3.772-1.436 5.207 0s1.436 3.772 0 5.207l-3.636 3.636c-.718.718-1.661 1.077-2.604 1.077h.001z',
    'M4.682 18.998c-.943 0-1.886-.359-2.604-1.077-1.436-1.436-1.436-3.772 0-5.207l3.636-3.636c1.436-1.436 3.772-1.436 5.207 0 .195.195.195.512 0 .707s-.512.195-.707 0c-1.046-1.046-2.747-1.046-3.793 0l-3.636 3.636c-1.046 1.046-1.046 2.747 0 3.793s2.747 1.046 3.793 0l3.068-3.068c.195-.195.512-.195.707 0s.195.512 0 .707l-3.068 3.068c-.718.718-1.661 1.077-2.604 1.077h.001z',
  ],
  height: 20,
  width: 20,
});
